/* eslint-disable jira/filename-case */
// Config moved here from https://bitbucket.org/atlassian/tesseract-runtime/src/3f10e7565def764b620b5c85c92b4dd3275dbd3c/services/deploy-service/src/params.ts#lines-247:249
// so that it is set consistently in regular Tesseract and Tesseract dynamic.
const SSR_FETCH_CONFIG_OVERRIDES = JSON.stringify({
	atlassianProxy: '/',
	useASAPForAnonymousAtlassianProxy: true,
	atlassianGraphQLGateway: '/gateway/api/graphql',
});

export const applySsrFetchConfigOverrideHeaders = (request: RequestInit): RequestInit => {
	return {
		...request,
		headers: {
			...request.headers,
			'x-ssr-fetch-config-overrides': SSR_FETCH_CONFIG_OVERRIDES,
		},
	};
};
